import Template from 'backbone/story/templates/comments/comment_list.js.hamlc'
import CommentView from 'backbone/story/views/comments/comment_view.js'
import InlineCommentUtils from 'utils/story/inline_comment_utils.js'
import CommentUtils from 'utils/story/comment_utils.js'

export default class CommentListView extends Backbone.View
  events:
    "change .js-resolved-filter"    : "onResolvedFilterChange"
    "change .js-commenter-filter"   : "onCommenterFilterChange"

  initialize: (options) ->
    @options = options || {}
    @commentViews = []
    @commentCollection = page.get("storyComments")
    @setupDefaultCollectionFilters()
    @inlineCommentUtils = new InlineCommentUtils()
    @setupListeners()

  setupListeners: ->
    @listenTo(@commentCollection, "change:resolved", @render)
    @listenTo(@commentCollection, "sync", @render)

  destroyListeners: ->
    @stopListening(@commentCollection, "change:resolved", @render)
    @stopListening(@commentCollection, "sync", @render)

  removeCommentViews: ->
    for commentView in @commentViews
      commentView.remove()

    @commentViews = []

  remove: ->
    @destroyListeners()
    @removeCommentViews()
    super()

  setupDefaultCollectionFilters: ->
    @collectionFilters = {}
    @collectionFilters["story_id"] = window.story.id
    @collectionFilters["resolved"] = 0

  onResolvedFilterChange: (e) =>
    @setFilter("resolved", parseInt(e.target.value, 10))
    @render()

  onCommenterFilterChange: (e) =>
    selectedFilter = e.target.value

    if selectedFilter == "mentioned"
      @setFilter("mentioned", true)
      @deleteFilter("authorable_id")
    else
      @setFilter("authorable_id", parseInt(selectedFilter))
      @deleteFilter("mentioned")

    @render()

  setFilter: (filter, val) ->
    @collectionFilters[filter] = val
    @deleteFilter(filter) if isNaN(@collectionFilters[filter])

  deleteFilter: (filter) -> delete @collectionFilters[filter]

  getCommenters: ->
    _.uniq(_.map(@commentCollection.models, (comment) ->
      { value: comment.get("authorable_id"), name: comment.get("authorable_name") }
    ), false, (comment) ->
      "#{comment.name}-#{comment.authorable_id}"
    )

  comments: ->
    @commentCollection.sort()
    @commentCollection.where(@collectionFilters)

  render: ->
    @updateLoadingMask()

    @options.comments = @comments()
    @options.commentCollection =  @commentCollection
    @options.collectionFilters = @collectionFilters
    @options.commenters = @getCommenters()

    @$el.html(Template(@options))

    @removeCommentViews()

    for comment in @comments()
      @commentViews.push(@renderCommentView(comment))

    if $("mark").length == 0
      $("body").find(".actions-other").removeClass("allow-comment")

    contently.ui.setup_validation(@$el)
    contently.ui.setup_select2(@$el)
    contently.ui.autosizeTextarea(@$el)

    if @$el.find("#comment_body").exists()
      CommentUtils.initCommentMentioning(@$el.find("#comment_body"))

    return this

  updateLoadingMask: ->
    $commentsContainer = $("article.comments")

    if @commentCollection.fetched == false
      $commentsContainer.maskLoading()
    else
      $commentsContainer.unmaskLoading()

  renderCommentView: (comment) ->
    commentView = new CommentView(
      comment: comment
      expandable: true
      expanded: false
      active: comment.isActive()
    )

    @$el.find(".js-comments").append(commentView.render().el)

    commentView



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/comments/comment_list_view.js.coffee